module.exports = __webpack_public_path__ + "img/cmmi.9f1eabbb.png";